__turbopack_context__.v({
  "floating": "style-module-scss-module__3HPDNG__floating",
  "nav": "style-module-scss-module__3HPDNG__nav",
  "nav--scrolled": "style-module-scss-module__3HPDNG__nav--scrolled",
  "nav__hamburger": "style-module-scss-module__3HPDNG__nav__hamburger",
  "nav__left-section": "style-module-scss-module__3HPDNG__nav__left-section",
  "nav__list": "style-module-scss-module__3HPDNG__nav__list",
  "nav__right-section": "style-module-scss-module__3HPDNG__nav__right-section",
  "nav__say-hello": "style-module-scss-module__3HPDNG__nav__say-hello",
  "nav__title": "style-module-scss-module__3HPDNG__nav__title",
  "nav_mobileBg": "style-module-scss-module__3HPDNG__nav_mobileBg",
  "nav_mobileHidden": "style-module-scss-module__3HPDNG__nav_mobileHidden",
  "otherNav": "style-module-scss-module__3HPDNG__otherNav",
  "rotate": "style-module-scss-module__3HPDNG__rotate",
});
